export default __webpack_public_path__ + "static/media/test.dafa45bb.svg";